import type { GiftCard, GiftCardSingle } from '../GiftCard.types'

export const isGiftCardSingle = (giftCard: GiftCard): giftCard is GiftCardSingle => 'id' in giftCard
